'use strict';

// TODO: Make everything handle signed int64 properly...

/**
 * A class for wrapping a 64-bit integer in Javascript to avoid loss
 * of precision issues at high values.
 */
export class Int64 {
  lo: number;
  hi: number;

  constructor(lo?: number, hi?: number) {
    if (lo === undefined && hi === undefined) {
      this.lo = 0;
      this.hi = 0;
    } else {
      this.lo = lo || 0;
      this.hi = hi || 0;
    }
  }

  isBitSet(bit: number): number {
    if (bit < 32) {
      return this.lo & (1 << bit);
    } else {
      return this.hi & (1 << (bit - 32));
    }
  }

  hasBits(other: Int64): number {
    return (this.hi & other.hi) | (this.lo & other.lo);
  }

  toString(radix?: number): string {
    let str = this.lo.toString(16);

    while (str.length < 8) {
      str = '0' + str;
    }

    return this.hi.toString(16) + str;
  }

  toNumber(): number {
    return this.hi << 32 | this.lo;
  }

  static fromBit(bit: number): Int64 {
    if (bit <= 31) {
      return new Int64(1 << bit, 0);
    } else {
      return new Int64(0, 1 << (bit - 31));
    }
  }
}

